export type { CheckoutOptions, InfraIoInstance, LoadOptions } from './types';
export { InfraIoError } from './errors';
export type { InfraIoErrorCode } from './errors';

import { InfraIo } from './checkout';
import { DEFAULT_CHECKOUT_ORIGIN } from './constants';
import { InfraIoError } from './errors';
import type { InfraIoInstance, LoadOptions } from './types';

/** SDK version. Replaced at build time from package.json. */
export const VERSION = '0.1.0';

// pk_live_ / pk_test_ prefix + at least one char. Structural check only —
// the gateway does the real validation.
const PK_PATTERN = /^pk_(live|test)_[A-Za-z0-9]+$/;

export async function loadInfraIo(
  publicKey: string,
  options?: LoadOptions,
): Promise<InfraIoInstance> {
  if (!publicKey || typeof publicKey !== 'string' || !PK_PATTERN.test(publicKey)) {
    throw new InfraIoError(
      'invalid_request_error',
      'Invalid public key. Expected format: pk_live_<hex> or pk_test_<hex>',
    );
  }
  const checkoutBaseURL = options?.checkoutUrl ?? DEFAULT_CHECKOUT_ORIGIN;
  return new InfraIo(publicKey, checkoutBaseURL);
}
